<template>
    <v-container fluid>
        <div v-if="!loading">
            <v-row justify="end">
                <information :text="`${text[locale.split('-')[0]]}`" />
            </v-row>
            <v-divider color="black" />
            <!--table head-->
            <v-row class="subtitle-2 my-2 px-2" no-gutters>
                <v-col v-for="(item, i) in headers" :key="i" 
                    :class="item.style"
                    :cols="item.cols">
                    {{ `${item.title}` | localize }}
                </v-col>
            </v-row>
            <v-divider color="black" />
            <div v-if="market_segments.length">
                <!--segments tab-->
                <div v-for="segment in market_segments" :key="segment.id">
                    <v-row class="body-2 my-1" no-gutters>
                        <v-col cols="2" class="text-left">{{ segment.segment?.name }}</v-col>
                        <v-col cols="9" class="text-left">{{ segment.segment?.description }}</v-col>
                        <v-col cols="1" class="text-center">{{ segment.segment?.motiv_level * 100 }} %</v-col>
                    </v-row>
                    <v-divider />
                </div>
            </div>
            <v-row v-else class="mt-4" justify="center">
                there are no segments yet
            </v-row>
        </div>
        <v-row v-else justify="center" class="mt-12">
            <loader />
        </v-row>
    </v-container>
</template>
<script>
import Information from '../../../layouts/Information.vue';
import Loader from '../../../layouts/Loader.vue';

export default {
    data() {
        return {
            headers: [
            {
                title: 'Segment',
                style: 'text-left',
                cols: 2
            }, 
            {
                title: 'Description',
                style: 'text-center',
                cols: 9
            },
            {
                title: 'Motivation to buy',
                style: 'text-center',
                cols: 1
            }, 
            ],
            text: {
                en: "This report outlines the market segments, detailing the characteristics of each [customer] group and assessing their readiness to purchase the products.",
                ro: "Acest raport prezintă segmentele de piață, detaliind caracteristicile fiecărui grup [clienții] și evaluând disponibilitatea acestora de a achiziționa produsele.",
                ru: "Настоящий отчет содержит обзор сегментов рынка с подробным описанием характеристик каждой группы [покупателей] и оценкой их готовности к приобретению данной продукции."
            }
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        game() {
            return this.$store.getters.game;
        },
        locale() {
            return this.$store.getters.locale;
        },
        market_segments() {
            return this.$store.getters.market_segments;
        },
    },
    methods: {
        localeNumber(num) {
            if (num) {
                if (this.locale == 'ro-RO') {
                    return num.toLocaleString('en-US')
                }
                return num.toLocaleString(this.locale)
            }
            return 0;
        },
    },
    components: {
        Information, Loader
    },
}
</script>
